import styled from 'styled-components';

import { COLORS } from 'theme';

import Tag from '../..';

export const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.majorelleBlueDark};
    background: ${COLORS.majorelleBlueLight};
    border-color: ${COLORS.majorelleBlue};
    border-radius: ${({ theme }) => theme.borderRadius.full};

    &&& .MuiChip-icon path {
      fill: ${COLORS.majorelleBlue};
    }
  }
`;
